import React, { ReactNode } from 'react';
import { IntlProvider } from 'react-intl';
import { Provider } from 'react-redux';
import { JRCThemeProvider } from 'jamespot-react-components';
import { store } from '../redux/initStore';
import { Translation } from '../utils/translation';

export type ExtensionProviderProps = {
    layout?: boolean;
    children?: ReactNode;
};

export const ExtensionProvider = ({ layout = false, children }: ExtensionProviderProps) => {
    const locale = J.locale ?? 'en';
    const messages = Translation.get(locale);
    return (
        <Provider store={store}>
            <IntlProvider
                locale={locale}
                messages={messages}
                onError={() => {
                    /* silent error */
                }}>
                <JRCThemeProvider layout={layout}>{children}</JRCThemeProvider>
            </IntlProvider>
        </Provider>
    );
};
